import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useDemoMode } from "../../../../contexts/DemoModeContext";
import { seedDemoDetailedShipments } from "../../../../reduxFolder/reducers/storage";
import { DEMO_SHIPMENT_IDS, demoDetailedShipments } from "./demoFixtures";

// Returns whether id belongs to a demo shipment and, when it does, seeds the
// detail cache — so direct loads of /parcels/inventory/<demo id> work without
// visiting the Storage page first. Off when the account setting disables
// samples, which leaves a stale demo link to the normal not-found path.
export const useDemoShipment = (id: number): boolean => {
  const dispatch = useDispatch();
  const { isDemoEnabled } = useDemoMode();
  const isDemo = isDemoEnabled && DEMO_SHIPMENT_IDS.includes(id);

  useEffect(() => {
    if (isDemo) dispatch(seedDemoDetailedShipments(demoDetailedShipments));
  }, [isDemo, dispatch]);

  return isDemo;
};
